import React, { createContext, useContext } from 'react';
import { Outlet } from 'react-router-dom';

const IsMainSectionContext = createContext();

export function useIsMainSection() {
    return useContext(IsMainSectionContext);
}

export default function IsMainSectionProvider() {
    return (
        <IsMainSectionContext.Provider value={true}>
            <Outlet />
        </IsMainSectionContext.Provider>
    );
}
